import { useMutation } from '@tanstack/react-query';

type Body = {
  email: string;
};

export const useCheckEmailSync = () => {
  const update = async (body: Body) => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL ?? ''}/api/auth/check-user-sync`,
      {
        headers: {
          'Content-Type': 'application/json',
          'client-id': process.env.NEXT_PUBLIC_CLIENT_ID ?? '',
        },
        method: 'POST',
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) {
      const errorBody = await res.json();
      throw new Error(errorBody.error || res.statusText);
    }
  };

  return useMutation<void, unknown, Body>({
    mutationFn: update,
  });
};
